import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';
import TableList from '@/components/TableList/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import { fetchGmakerTemplateList, deleteGmakerTemplate, activateGmakerTemplate } from '@/api/gmaker/template';
import copyCommonDialog from '@/views/butler/creative-direction/copyCommonDialog';
import { updateGmakerTemplate } from '@/api/gmaker/template.js';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import previewModal from '@/components/PreviewModal';
import { getPreviewApiRequest } from '@/store/creative/template/preview.js';
import ActionsNameDialog from '@/views/butler/creative-direction/manager/actions-name-dialog.vue';
import { parseTime } from '@/filters/index';
import CreateProjectBtn from './create-project-dialog.vue';

var topSelect = [{
  value: 1,
  label: '置顶'
}, {
  value: 2,
  label: '不置顶'
}];

export default {
  components: {
    SearchBar: SearchBar,
    TableList: TableList,
    Pagination: Pagination,
    copyCommonDialog: copyCommonDialog,
    previewModal: previewModal,
    ActionsNameDialog: ActionsNameDialog,
    CreateProjectBtn: CreateProjectBtn
  },

  mixins: [searchMixin],

  data: function data() {
    return {
      listLoading: true,
      // 请求参数
      query: {
        page: 1,
        page_size: 15,
        id: '',
        name: '',
        src_template_id: '',
        src_template_name: '',
        industry_categories: [],
        material_categories: [],
        is_top: '',
        is_allow_ps: '',
        is_active: '',
        dimension_types: [],
        order: '',
        original_template_id: ''
      },
      pagination: {
        total: 0
      },
      actionsDialog: {
        visible: false,
        type: 'journey', // 埋点名称
        data: {},
        journeyData: {}
      },
      // 表单数据
      list: [],
      copyDialog: {
        visible: false
      },
      templateInfo: {},
      industryList: [],
      playMethodList: [],
      previewLoading: false,
      previewDialog: {
        visible: false,
        title: '',
        html_url: '',
        showCnUrl: false,
        id: ''
      },
      parseTime: parseTime
    };
  },


  watch: {
    $route: function $route(to, from) {
      this.getTemplateList(this.query);
    }
  },

  computed: {
    isProxyTemplate: function isProxyTemplate() {
      var path = this.$route.path;
      var index = path.lastIndexOf('/');
      return path.substring(index + 1, path.length) === 'proxyTemplate';
    },

    // 搜索栏配置
    formItemList: function formItemList() {
      return [{
        type: 'input',
        prop: 'original_template_id',
        params: {
          clearable: true,
          placeholder: '' + (this.isProxyTemplate ? '请输入模板ID' : '请输入通用模板ID')
        },
        visible: true
      }, {
        type: 'input',
        prop: 'id',
        params: {
          clearable: true,
          placeholder: '请输入模板版本ID'
        },
        visible: !this.isProxyTemplate
      }, {
        type: 'input',
        prop: 'name',
        params: {
          clearable: true,
          placeholder: '' + (this.isProxyTemplate ? '请输入模板名称' : '请输入通用模板名称')
        },
        visible: true
      }, {
        type: 'input',
        prop: 'src_template_id',
        params: {
          clearable: true,
          placeholder: '请输入来源创意方向ID'
        },
        visible: !this.isProxyTemplate
      }, {
        type: 'input',
        prop: 'src_template_name',
        params: {
          clearable: true,
          placeholder: '请输入来源创意方向名称'
        },
        visible: !this.isProxyTemplate
      }, {
        type: 'select',
        prop: 'industry_categories',
        params: {
          placeholder: '请选择行业类型',
          clearable: true,
          filterable: true,
          multiple: true,
          'collapse-tags': true,
          options: this.industryList
        },
        visible: !this.isProxyTemplate
      }, {
        type: 'select',
        prop: 'is_allow_ps',
        visible: !this.isProxyTemplate,
        params: {
          clearable: true,
          placeholder: '请选择是否授权PS',
          options: [{
            label: 'Yes',
            value: 1
          }, {
            label: 'No',
            value: 2
          }]
        }
      }, {
        type: 'select',
        prop: 'playunit',
        visible: !this.isProxyTemplate,
        params: {
          clearable: true,
          placeholder: '请选择是否支持快捷排版',
          options: [{
            label: 'Yes',
            value: 1
          }, {
            label: 'No',
            value: 2
          }]
        }
      }, {
        type: 'select',
        prop: 'wxgame',
        visible: !this.isProxyTemplate,
        params: {
          clearable: true,
          placeholder: '是否开放小游戏原生试玩',
          options: [{
            label: 'Yes',
            value: 1
          }, {
            label: 'No',
            value: 2
          }]
        }
      }, {
        type: 'cascader',
        prop: 'play_methods',
        visible: !this.isProxyTemplate,
        params: {
          clearable: true,
          props: {
            children: 'child',
            emitPath: false,
            multiple: true,
            label: 'name',
            value: 'id'
          },
          placeholder: '请选择玩法',
          'collapse-tags': true,
          'show-all-levels': false,
          options: this.playMethodList
        }
      }, {
        type: 'select',
        prop: 'difficulty_levels',
        visible: !this.isProxyTemplate,
        params: {
          placeholder: '请选择难度等级',
          clearable: true,
          filterable: true,
          multiple: true,
          'collapse-tags': true,
          options: this.difficultyList
        }
      },
      // {
      //   type: 'select',
      //   prop: 'material_categories',
      //   params: {
      //     placeholder: '请选择素材类型',
      //     clearable: true,
      //     filterable: true,
      //     multiple: true,
      //     'collapse-tags': true,
      //     options: this.materialCategory,
      //   },
      // },
      {
        type: 'select',
        prop: 'is_top',
        visible: !this.isProxyTemplate,
        params: {
          placeholder: '请选择置顶状态',
          clearable: true,
          filterable: true,
          options: topSelect
        }
      }, {
        type: 'select',
        prop: 'is_active',
        visible: !this.isProxyTemplate,
        params: {
          placeholder: '请选择授权状态',
          clearable: true,
          filterable: true,
          options: [{
            value: 1,
            label: '已授权'
          }, {
            value: 2,
            label: '未授权'
          }]
        }
      }, {
        type: 'select',
        prop: 'dimension_types',
        visible: !this.isProxyTemplate,
        params: {
          placeholder: '请选择模板类型',
          clearable: true,
          filterable: false,
          multiple: true,
          options: this.modelTypeList
        }
      }].filter(function (item) {
        return item.visible;
      });
    },

    // 表格配置
    tableColumnConfig: function tableColumnConfig() {
      var self = this;
      return [{
        label: '' + (self.isProxyTemplate ? '模板ID' : '通用模板ID'),
        prop: 'original_template_id',
        width: 120,
        align: 'center',
        visible: true
      }, {
        label: '模板版本ID',
        prop: 'id',
        width: 120,
        align: 'center',
        visible: !self.isProxyTemplate
      }, {
        slot: 'thumbnail-cell',
        visible: true
      }, {
        slot: 'name-cell',
        visible: true
      }, {
        label: '来源创意方向ID',
        prop: 'src_template_id',
        width: 120,
        align: 'center',
        visible: !self.isProxyTemplate,
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            if (row.source !== 'ps') {
              return row.src_template_id;
            }
            return '-';
          }
        }
      }, {
        slot: 'basic-cell',
        visible: true
      }, {
        label: '来源创意方向名称',
        prop: 'src_template_name',
        align: 'center',
        visible: !self.isProxyTemplate,
        params: {
          innerText: function innerText(_ref2) {
            var row = _ref2.row;

            if (row.source !== 'ps') {
              return row.src_template_name;
            }
            return '-';
          }
        }
      }, {
        label: '行业类型',
        prop: 'industry_categories_name',
        align: 'center',
        visible: !self.isProxyTemplate
      }, {
        label: '玩法',
        prop: 'play_methods_name',
        align: 'center',
        visible: !self.isProxyTemplate
      }, {
        label: '难度等级',
        prop: 'difficulty_level',
        align: 'center',
        visible: !self.isProxyTemplate,
        params: {
          innerText: function innerText(_ref3) {
            var row = _ref3.row;

            return useValueExchangeLabel(row.difficulty_level, self.difficultyList) || '-';
          }
        }
      }, {
        label: '模板类型',
        prop: 'dimension_type',
        align: 'center',
        visible: !self.isProxyTemplate,
        params: {
          innerText: function innerText(_ref4) {
            var row = _ref4.row;

            return useValueExchangeLabel(row.dimension_type, self.modelTypeList) || '-';
          }
        }
      },
      // {
      //   label: '素材类型',
      //   prop: 'material_category',
      //   align: 'center',
      //   params: {
      //     innerText({ row }) {
      //       return useValueExchangeLabel(
      //         row.material_category,
      // self.materialCategory,
      //       )
      //     },
      //   },
      // },
      {
        label: '使用次数',
        prop: 'used_times',
        sortable: 'custom',
        width: 150,
        align: 'center',
        visible: !self.isProxyTemplate
      }, {
        label: '近30天模版使用数',
        prop: 'recent_used_times',
        width: 150,
        sortable: 'custom',
        align: 'center',
        visible: !self.isProxyTemplate
      }, {
        slot: 'edit-time-cell',
        visible: !self.isProxyTemplate
      }, {
        slot: 'updated-time-cell',
        visible: true
      }, {
        slot: 'created-time-cell',
        visible: true
      }, {
        slot: 'top-cell',
        visible: !self.isProxyTemplate
      }, {
        slot: 'authorize-cell',
        visible: !self.isProxyTemplate
      }, {
        slot: 'action-cell',
        visible: true
      }].filter(function (item) {
        return item.visible;
      });
    }
  },

  methods: {
    getPreviewDialog: function getPreviewDialog(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var apiParams, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                apiParams = getPreviewApiRequest({
                  id: item.id,
                  skinId: _.get(item, 'skins[0].id') || '',
                  page: 'common-template'
                });

                _this.previewLoading = true;
                _context.next = 5;
                return apiParams.request(apiParams.params);

              case 5:
                res = _context.sent;

                _this.previewLoading = false;
                _this.previewDialog.visible = true;
                _this.previewDialog.title = item.name;
                _this.previewDialog.html_url = _.get(res, 'data.data.preview_url');
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                _this.previewLoading = false;
                console.log(_context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12]]);
      }))();
    },
    getTemplateList: function getTemplateList(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, getNameListByIds, getFlatArr, filterbrandLabel, getPlayMethodListByIds;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                filterbrandLabel = function filterbrandLabel(data, value) {
                  var labelAll = [];
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = _getIterator(value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var item = _step.value;
                      var _iteratorNormalCompletion2 = true;
                      var _didIteratorError2 = false;
                      var _iteratorError2 = undefined;

                      try {
                        for (var _iterator2 = _getIterator(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                          var v = _step2.value;

                          if (Number(item) === v.id) {
                            labelAll.push(v.name);
                          }
                        }
                      } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }
                        } finally {
                          if (_didIteratorError2) {
                            throw _iteratorError2;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  return labelAll.length > 0 ? labelAll.join(',') : '-';
                };

                getFlatArr = function getFlatArr(arr) {
                  return arr.reduce(function (a, item) {
                    var flatArr = [].concat(_toConsumableArray(a), [item]);
                    if (item.child) {
                      flatArr = [].concat(_toConsumableArray(flatArr), _toConsumableArray(getFlatArr(item.child)));
                    }
                    return flatArr;
                  }, []);
                };

                _this2.listLoading = true;
                _context2.next = 5;
                return fetchGmakerTemplateList(_extends({}, params, {
                  is_spend_share: _this2.isProxyTemplate ? 1 : 0
                }));

              case 5:
                res = _context2.sent;

                _this2.listLoading = false;

                if (!(res.status !== 200)) {
                  _context2.next = 10;
                  break;
                }

                _this2.$message.error('获取列表错误');
                return _context2.abrupt('return');

              case 10:
                getNameListByIds = function getNameListByIds(ids, array) {
                  var templateIdsTemp = [];
                  templateIdsTemp = ids.split(',');
                  return templateIdsTemp.map(function (item) {
                    return useValueExchangeLabel(Number(item), array) || '-';
                  }).join();
                };

                getPlayMethodListByIds = function getPlayMethodListByIds(ids, array) {
                  var templateIdsTemp = [];
                  templateIdsTemp = ids.split(',');
                  var newarry = getFlatArr(array);
                  return filterbrandLabel(newarry, templateIdsTemp);
                };

                _this2.list = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    industry_categories_name: getNameListByIds(item.industry_categories, _this2.industryList),
                    play_methods_name: getPlayMethodListByIds(item.play_methods, _this2.playMethodList)
                  });
                });
                _this2.pagination.total = _.get(res, 'data.data.total');

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    showTemplateDialog: function showTemplateDialog(item) {
      this.copyDialog.visible = true;
      this.templateInfo = _extends({}, _.pick(item, ['id', 'name', 'name_en', 'description', 'description_en', 'material_category', 'industry_categories', 'estimate_time', 'src_template_id', 'src_template_name', 'thumbnail', 'thumbnail_l', 'play_methods', 'is_allow_ps', 'enable_gameconfig', 'enable_ps_actions', 'enable_playunit', 'enable_wxgame', 'enable_rigid_body', 'difficulty_level', 'dimension_type']));
    },
    timeSort: function timeSort(a, b) {
      return a.updated_time - b.updated_time;
    },
    toCommonTemplate: function toCommonTemplate(id, skins) {
      var skinId = _.get(skins, ['0', 'id']);
      if (!skinId) {
        this.$message.error('该模板缺少皮肤');
        return;
      }
      this.$router.push({
        name: 'creative.common-template',
        params: {
          templateId: id,
          skinId: skinId
        }
      });
    },
    deleteTemplate: function deleteTemplate(id) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return deleteGmakerTemplate({ id: id });

              case 2:
                res = _context3.sent;

                if (!(res.status !== 200)) {
                  _context3.next = 6;
                  break;
                }

                _this3.$message.error('删除失败');
                return _context3.abrupt('return');

              case 6:
                _this3.$message.success('删除成功');
                _this3.getTemplateList(_this3.query);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleUpdateSuccess: function handleUpdateSuccess() {
      this.getTemplateList(this.query);
    },
    handleTopSwitchChange: function handleTopSwitchChange(template) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return updateGmakerTemplate({
                  id: template.id,
                  is_top: template.is_top === 1 ? 2 : 1
                });

              case 2:
                _context4.next = 4;
                return _this4.getTemplateList(_this4.query);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleActiveSwitchChange: function handleActiveSwitchChange(template) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return updateGmakerTemplate({
                  id: template.id,
                  is_active: template.is_active === 1 ? 2 : 1
                });

              case 2:
                _context5.next = 4;
                return _this5.getTemplateList(_this5.query);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    handleActionsJourney: function handleActionsJourney(row, type) {
      this.actionsDialog.visible = true;
      this.actionsDialog.data = row;
      this.actionsDialog.type = type;
      this.actionsDialog.journeyData = {
        actionNameDictionary: row.actions,
        user_journeys: row.user_journeys
      };
    },
    handleSetActionJourney: function handleSetActionJourney(data) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var postData;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                postData = {};

                postData.user_journeys = _JSON$stringify(data.journey);
                postData.actions = _JSON$stringify(data.actions);
                _context6.next = 5;
                return updateGmakerTemplate(_extends({
                  id: _this6.actionsDialog.data.id
                }, postData));

              case 5:
                _this6.getTemplateList(_this6.query);

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    handleActivateTmpl: function handleActivateTmpl(id) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var res;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this7.listLoading = true;
                _context7.next = 4;
                return activateGmakerTemplate({ id: id });

              case 4:
                res = _context7.sent;

                if (!res.data.code) {
                  _this7.$message.success('激活成功');
                  _this7.getTemplateList(_this7.query);
                } else {
                  _this7.$message.error(res.data.msg);
                }
                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7['catch'](0);

                console.log(_context7.t0);

              case 11:
                _context7.prev = 11;

                _this7.listLoading = false;
                return _context7.finish(11);

              case 14:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 8, 11, 14]]);
      }))();
    },
    handleSortChange: function handleSortChange(_ref5) {
      var column = _ref5.column,
          prop = _ref5.prop,
          order = _ref5.order;

      if (order === 'ascending') {
        this.query.order = prop;
      } else if (order === 'descending') {
        this.query.order = '-' + prop;
      } else {
        this.query.order = '';
      }
      this.getTemplateList(this.query);
    },
    handleCreateProject: function handleCreateProject() {}
  },

  mounted: function mounted() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var res;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this8.$store.dispatch('config/getGmakerConfig');

            case 2:
              res = _context8.sent;

              _this8.industryList = (_.get(res, 'industry_categories') || []).map(function (item) {
                return _extends({}, item, {
                  label: item.name,
                  value: item.id
                });
              }) || [];
              _this8.playMethodList = (_.get(res, 'play_methods') || []).map(function (item) {
                return _extends({}, item, {
                  label: item.name,
                  value: item.id
                });
              }) || [];
              _this8.materialCategory = (_.get(res, 'material_categories') || []).map(function (item) {
                return _extends({}, item, {
                  label: item.name,
                  value: item.id
                });
              });
              _this8.difficultyList = (_.get(res, 'difficulty_levels') || []).map(function (item) {
                return _extends({}, item, {
                  label: item.name,
                  value: item.id
                });
              }) || [];

              _this8.modelTypeList = (_.get(res, 'dimension_types') || []).map(function (item) {
                return _extends({}, item, {
                  label: item.name,
                  value: item.id
                });
              }) || [];

              _this8.getTemplateList(_this8.query);

            case 9:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
};